/* ================= PROGRESS BAR + TOC ================= */

(function () {

  /* ---- cached layout values ---- */
  var articleTop = 0;
  var articleBottom = 0;
  var articleRight = 0;

  function cacheLayout() {
    var article = document.querySelector("#article-body");
    if (!article) return;

    var rect = article.getBoundingClientRect();

    /*
     * articleTop / articleBottom are DOCUMENT coordinates.
     * articleRight is a VIEWPORT coordinate because the TOC
     * uses position:fixed.
     */
    articleTop = rect.top + window.scrollY;
    articleBottom = rect.bottom + window.scrollY;
    articleRight = rect.right;
  }


  /* ---- RAF throttle helper ---- */
  function rafThrottle(fn) {
    var ticking = false;

    return function () {
      if (!ticking) {
        ticking = true;

        requestAnimationFrame(function () {
          fn();
          ticking = false;
        });
      }
    };
  }


  /* ---- Progress bar ---- */
  function updateProgress() {
    var bar = document.querySelector(".wd-progress__fill");
    if (!bar) return;

    var docHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    if (docHeight <= 0) return;

    bar.style.width =
      ((window.pageYOffset / docHeight) * 100) + "%";
  }


  /* ---- TOC positioning ---- */
  var toc;
  var lastState = "";


  function positionTOC() {
    if (!toc) return;

    var scrollY = window.scrollY;


    /* ==========================================
       MOBILE
       ========================================== */

    if (window.innerWidth < 1100) {

      if (lastState !== "mobile") {

        toc.style.cssText =
          "position:static;" +
          "width:100%;" +
          "display:block;";

        lastState = "mobile";
      }

      return;
    }


    var sidebarOffset = 50;


    /* ==========================================
       ABOVE ARTICLE
       ========================================== */

    if (scrollY < articleTop) {

      if (lastState !== "above") {

        toc.style.cssText =
          "display:none;";

        lastState = "above";
      }

      return;
    }


    /* ==========================================
       INSIDE ARTICLE
       ========================================== */

    if (scrollY < articleBottom - window.innerHeight) {

      if (lastState !== "fixed") {

        toc.style.cssText =
          "display:block;" +
          "position:fixed;" +
          "top:110px;" +
          "left:" + (articleRight + sidebarOffset) + "px;" +
          "width:260px;";

        lastState = "fixed";
      }

      return;
    }


    /* ==========================================
       ARTICLE BOTTOM
       
       IMPORTANT:
       Keep the TOC FIXED.
       
       Its bottom is locked to the bottom of
       #article-body in DOCUMENT coordinates.
       ========================================== */

    var tocHeight = toc.offsetHeight;

    /*
     * Convert the article's document bottom into
     * a viewport position.
     *
     * Example:
     *
     * article bottom = 2500px document
     * scroll position = 2100px
     *
     * article bottom on screen = 400px
     *
     * TOC top = 400px - TOC height
     *
     * Therefore the TOC bottom sits exactly
     * at the article bottom.
     */
    var bottomTop =
      articleBottom -
      scrollY -
      tocHeight;


    toc.style.cssText =
      "display:block;" +
      "position:fixed;" +
      "top:" + bottomTop + "px;" +
      "left:" + (articleRight + sidebarOffset) + "px;" +
      "width:260px;";

    lastState = "bottom";
  }


  /* ---- Scroll handler ---- */
  var onScroll = rafThrottle(function () {

    updateProgress();
    positionTOC();

  });


  /* ---- Resize handler ---- */
  var onResize = rafThrottle(function () {

    cacheLayout();

    lastState = "";

    positionTOC();
    updateProgress();

  });


  window.addEventListener(
    "scroll",
    onScroll,
    { passive: true }
  );

  window.addEventListener(
    "resize",
    onResize,
    { passive: true }
  );


  /* ==========================================
     INITIALIZATION
     ========================================== */

  document.addEventListener(
    "DOMContentLoaded",
    function () {


      /* --------------------------------------
         Remove legacy TOC elements
         -------------------------------------- */

      document
        .querySelectorAll(
          ".wd-toc, .wd-toc-fixed"
        )
        .forEach(function (el) {
          el.remove();
        });


      toc =
        document.querySelector("#blog-toc");

      var tocList =
        document.querySelector("#wd-toc-list");

      var article =
        document.querySelector("#article-body");


      /* --------------------------------------
         Progress bar host
         -------------------------------------- */

      var host =
        document.querySelector(".wd-progress");

      if (host) {

        host.style.cssText =
          "position:fixed;" +
          "top:0;" +
          "left:0;" +
          "width:100%;" +
          "height:4px;" +
          "background:transparent;" +
          "z-index:2147483647;";
      }


      /* --------------------------------------
         Build TOC
         -------------------------------------- */

      if (article && toc && tocList) {

        var headings =
          article.querySelectorAll(
            "h2, h3"
          );


        if (headings.length === 0) {

          toc.style.display = "none";

        } else {

          tocList.innerHTML = "";


          headings.forEach(
            function (heading) {

              var text =
                heading.textContent.trim();


              /* Create heading ID if missing */
              if (!heading.id) {

                heading.id =
                  text
                    .toLowerCase()
                    .replace(
                      /[^a-z0-9\u00C0-\u017F\s]/g,
                      ""
                    )
                    .replace(
                      /\s+/g,
                      "-"
                    );
              }


              var li =
                document.createElement("li");


              if (
                heading.tagName === "H3"
              ) {
                li.classList.add(
                  "toc-h3"
                );
              }


              var link =
                document.createElement("a");


              link.href =
                "#" + heading.id;

              link.textContent =
                text;


              li.appendChild(link);

              tocList.appendChild(li);

            }
          );


          /* --------------------------------
             Active section observer
             -------------------------------- */

          var links =
            document.querySelectorAll(
              "#blog-toc a"
            );


          var observer =
            new IntersectionObserver(
              function (entries) {

                entries.forEach(
                  function (entry) {

                    if (
                      entry.isIntersecting
                    ) {

                      links.forEach(
                        function (l) {
                          l.classList.remove(
                            "active"
                          );
                        }
                      );


                      var active =
                        document.querySelector(
                          '#blog-toc a[href="#' +
                          entry.target.id +
                          '"]'
                        );


                      if (active) {
                        active.classList.add(
                          "active"
                        );
                      }

                    }

                  }
                );

              },
              {
                rootMargin:
                  "-40% 0px -55% 0px"
              }
            );


          headings.forEach(
            function (h) {
              observer.observe(h);
            }
          );

        }


        /* --------------------------------
           Initial layout calculation
           -------------------------------- */

        cacheLayout();
        positionTOC();


        /* --------------------------------
           Watch article height changes
           
           This is important because images,
           fonts, Shopify sections, etc. can
           change the article height after
           the page initially loads.
           -------------------------------- */

        if (
          typeof ResizeObserver !==
          "undefined"
        ) {

          var articleResizeObserver =
            new ResizeObserver(
              rafThrottle(
                function () {

                  cacheLayout();

                  lastState = "";

                  positionTOC();

                }
              )
            );


          articleResizeObserver.observe(
            article
          );
        }

      }


      updateProgress();

    }
  );

})();